import { isCustomerFeatureEnabled } from 'src/data/customer';
import { BE_CUSTOMER_FEATURES } from 'src/lib/featureFlags';

// @ts-expect-error - useCurrentCustomer has no TypeScript declarations
import { useCurrentCustomer } from './useCurrentCustomer';

export const useCustomerSfAiChatEnabled = (): boolean => {
  const customer = useCurrentCustomer();

  return isCustomerFeatureEnabled(customer, BE_CUSTOMER_FEATURES.supportSfAiChat);
};
